 var swiper = new Swiper(".mySwiperx111", {
     // Default parameters
  slidesPerView: 4.8,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.5,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1.5,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 4.8,
      spaceBetween: 40
    }
  },
      navigation: {
        nextEl: ".swiper-button-next1",
        prevEl: ".swiper-button-prev1",
      },
    });

 var swiper = new Swiper(".mySwiperx2", {
     // Default parameters
  slidesPerView: 3,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 3,
      spaceBetween: 10
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
      spaceBetween: 10
    },
    // when window width is >= 640px
    640: {
      slidesPerView:3,
      spaceBetween: 10
    }
  },
      navigation: {
        nextEl: ".swiper-button-next2",
        prevEl: ".swiper-button-prev2",
      },
    });


 var swiper = new Swiper(".mySwiperx3", {
     // Default parameters
  slidesPerView: 1.4,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.4,
      spaceBetween: 10
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10
    },
    // when window width is >= 640px
    640: {
      slidesPerView:1.4,
      spaceBetween: 10
    }
  },
      navigation: {
        nextEl: ".swiper-button-next3",
        prevEl: ".swiper-button-prev3",
      },
    });

  var swiper = new Swiper(".slider-t", {
      spaceBetween: 10,
      slidesPerView: 2,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".slider-c", {
      spaceBetween: 10,
        loop:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });


    if (window.innerWidth <= 768) {
  document.querySelectorAll('.footer-block--menu h2').forEach(h => {
    if (h.dataset.init) return;
    h.dataset.init = '1';

    const ul = h.nextElementSibling;
    if (!ul || ul.tagName !== 'UL') return;

    h.style.cursor = 'pointer';
    h.style.position = 'relative';
    h.style.paddingRight = '20px';

    const icon = document.createElement('span');
    icon.textContent = '+';
    icon.style.position = 'absolute';
    icon.style.right = '0';
    icon.style.top = '0';
    icon.style.fontSize = '18px';
    icon.style.transition = 'transform 0.3s ease';
    h.appendChild(icon);

    ul.style.maxHeight = '0';
    ul.style.overflow = 'hidden';
    ul.style.transition = 'max-height 0.35s ease';

    h.addEventListener('click', () => {
      const open = ul.style.maxHeight && ul.style.maxHeight !== '0px';
      ul.style.maxHeight = open ? '0' : ul.scrollHeight + 'px';
      icon.style.transform = open ? 'rotate(0deg)' : 'rotate(45deg)';
    });
  });
}


document.addEventListener('DOMContentLoaded', function () {
  const desc = document.querySelector('.product__description.des_mob');

  if (desc && !desc.querySelector('.toggle-desc-btn')) { // Prevent duplicate button
    const btn = document.createElement('button');
    btn.className = 'toggle-desc-btn';
    btn.innerHTML = `
      Show More 
      <span class="arrowx">
        <img src="https://cdn.shopify.com/s/files/1/0892/1599/2113/files/downa.png?v=1756232890" 
             alt="Down Arrow" 
             style="width:16px; height:16px; transform: rotate(0deg); transition: transform 0.3s;">
      </span>
    `;

    desc.insertAdjacentElement('beforeend', btn);

    btn.addEventListener('click', function () {
      desc.classList.toggle('expanded');
      btn.classList.toggle('expanded');

      if (desc.classList.contains('expanded')) {
        btn.innerHTML = `
          Show Less 
          <span class="arrowx">
            <img src="https://cdn.shopify.com/s/files/1/0892/1599/2113/files/downa.png?v=1756232890" 
                 alt="Down Arrow" 
                 style="width:16px; height:16px; transform: rotate(180deg); transition: transform 0.3s;">
          </span>`;
      } else {
        btn.innerHTML = `
          Show More 
          <span class="arrowx">
            <img src="https://cdn.shopify.com/s/files/1/0892/1599/2113/files/downa.png?v=1756232890" 
                 alt="Down Arrow" 
                 style="width:16px; height:16px; transform: rotate(0deg); transition: transform 0.3s;">
          </span>`;
      }
    });
  }
});


  

$(".prod_det_top h4").click(function(){
$(".prod_det_top h4").removeClass("active")
     $(this).addClass("active");
    var xt=$(this).attr("data-action");
    $(".prod_detcon .tb").hide();
    $("."+xt).show();
    
})


function waitForRechargeElements(retries = 30, delay = 300) {
  const widget = document.querySelector('recharge-subscription-widget');
  if (!widget || !widget.shadowRoot) {
    if (retries > 0) {
      return setTimeout(() => waitForRechargeElements(retries - 1, delay), delay);
    }
    console.warn('Recharge widget or shadowRoot not found.');
    return;
  }

  const shadowRoot = widget.shadowRoot;
  const container = shadowRoot.querySelector('.rc-selection__root');
  const options = shadowRoot.querySelectorAll('.rc-purchase-option');

  if (!container || options.length === 0) {
    if (retries > 0) {
      return setTimeout(() => waitForRechargeElements(retries - 1, delay), delay);
    }
    console.warn('Recharge widget inner elements not found.');
    return;
  }

  // Proceed if everything is available
  setupRechargePriceUpdater(container, options);
}

function setupRechargePriceUpdater(container, options) {
  const getPriceFromOption = (option) => {
    if (option.classList.contains('rc-purchase-option__subscription')) {
      const discounted = option.querySelector('[part="rc-purchase-option__discounted-price"]');
      if (discounted) {
        return discounted.textContent.replace(/[^\d.]/g, '');
      }
    }
    const priceEl = option.querySelector('.rc-price:not([part="rc-purchase-option__discounted-price"])');
    if (priceEl) {
      return priceEl.textContent.replace(/[^\d.]/g, '');
    }
    return null;
  };

  const updatePrice = () => {
    options.forEach((option, index) => {
      if (option.hasAttribute('rc-selected')) {
        const price = getPriceFromOption(option);
        if (price) {
          $(".product-form__submit span:first-child").html('$' + price + " - ");
        }
      }
    });
  };

  updatePrice();

  const observer = new MutationObserver(updatePrice);
  options.forEach(option => {
    observer.observe(option, {
      attributes: true,
      attributeFilter: ['rc-selected'],
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  waitForRechargeElements();
});

